import { store } from '@core/Store'

/* istanbul ignore file */
const logger = (color: string, prefix: string, message: string, ...optionalParams: unknown[]) => {
  const isKambiLoggingEnabled = store.getState().toolbox.isKambiLoggingEnabled
  if (!isKambiLoggingEnabled) return

  // eslint-disable-next-line no-console
  console.log(
    `%c${prefix !== '' ? `${prefix}: ` : ``}${message}`,
    `color:${color}`,
    ...optionalParams
  )
}

export const createLogger = (color = 'green', prefix = '') => {
  return (message: string, ...optionalParams: unknown[]): void =>
    logger(color, prefix, message, ...optionalParams)
}

export const kambiLog = createLogger('green', 'KAMBI')
